import { DescendantContentBlock } from "services/KnowfullyAdminClient";

type ContentBlockValueProps = {
  value: DescendantContentBlock;
};

const ContentBlockValue = ({ value }: ContentBlockValueProps) => {
  if (!value?.value) {
    return <span>-</span>;
  }

  return (
    <div
      dangerouslySetInnerHTML={{ __html: value.value }}
      style={{ maxHeight: "200px", overflow: "auto" }}
    />
  );
};

export default ContentBlockValue;
